/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Akses_GInputs */

const en_tut_akses_g = /** @type {(inputs: Tut_Akses_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not every room should be open to everyone. Area access decides who may enter, and knocking gives a polite route in for people who do not have access yet.`)
};

const id_tut_akses_g = /** @type {(inputs: Tut_Akses_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak semua ruang perlu terbuka untuk semua orang. Akses area menentukan siapa yang boleh masuk, dan ketuk pintu memberi jalan yang sopan bagi yang belum punya akses.`)
};

/**
* | output |
* | --- |
* | "Not every room should be open to everyone. Area access decides who may enter, and knocking gives a polite route in for people who do not have access yet." |
*
* @param {Tut_Akses_GInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_akses_g = /** @type {((inputs?: Tut_Akses_GInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Akses_GInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_akses_g(inputs)
	return en_tut_akses_g(inputs)
});